import * as Yup from 'yup';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    shipmentCancellationReasonId: Yup.string()
      .required(t('Cancellation Reason is required'))
      .typeError(t('Cancellation Reason is required'))
    // shipmentCancellationNotes: Yup.string()
    //   .required(t('Cancellation notes are required'))
    //   .typeError(t('Cancellation notes are required'))
  });

export default validationSchema;
